import SettingFrame from "../../../../../components/@settings/SettingFrame"
import ConsoleMain from "../../../../../components/@schedulers/console/ConsoleMain"

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function ConsolePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ConsoleMain 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       